import type { ReactNode } from 'react';

import { cn, cva, type VariantProps } from '../../shared';
import { HEADER_HEIGHT } from '../app-shell/header-size';

export const footerVariants = cva(
  'bg-card text-card-foreground px-page-x gap-inline flex w-full items-center justify-between',
  {
    variants: {
      size: HEADER_HEIGHT,
      sticky: { true: 'sticky bottom-0 z-sticky', false: '' },
      border: { true: 'border-border border-t', false: '' },
      hidden: { true: 'invisible', false: '' },
    },
    defaultVariants: { size: 'md', sticky: false, border: true, hidden: false },
  },
);

type FooterVariants = VariantProps<typeof footerVariants>;

export interface FooterProps {
  size?: NonNullable<FooterVariants['size']>;
  sticky?: boolean;
  border?: boolean;
  hidden?: boolean;
  copyright?: ReactNode;
  version?: ReactNode;
  links?: ReactNode;
  className?: string;
}

export function Footer({
  size,
  sticky,
  border,
  hidden,
  copyright,
  version,
  links,
  className,
}: FooterProps) {
  return (
    <footer
      aria-hidden={hidden ? true : undefined}
      className={cn(footerVariants({ size, sticky, border, hidden }), className)}
    >
      <div className="gap-inline text-caption text-muted-foreground flex min-w-0 items-center">
        {copyright}
        {version}
      </div>
      {links ? <div className="gap-inline flex shrink-0 items-center">{links}</div> : null}
    </footer>
  );
}
